import { NameTerritoryLayout } from '../interfaces';

export const NAME_TERRITORY_LAYOUT: NameTerritoryLayout = {
    accordions: [
        {
            header: 'Latitudes',
            field: 'territoryCoordinates',
            index: 0,
        },
        {
            header: 'Longitudes',
            field: 'territoryCoordinates',
            index: 1,
        },
    ],

    details: [
        {
            label: 'Assigned Dealer',
            field: 'assignedTo',
        },
        {
            label: 'State',
            field: 'state',
        },
        {
            label: 'Total Area',
            field: 'area',
            suffix: ' km²',
            format: 'fixed2',
        },
        {
            label: 'Created',
            field: 'createdAt',
            format: 'date',
        },
    ],
} as const;
